import { render, staticRenderFns } from "./DespachoDetalleComponent.vue?vue&type=template&id=4519f873&"
import script from "./DespachoDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./DespachoDetalleComponent.vue?vue&type=script&lang=js&"
import style0 from "./DespachoDetalleComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports